import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

export const CloseButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#FFFFFF',
  border: `1px solid ${theme?.primary || '#000'}`,
  borderRadius: '8px',
  fontSize: 18,
  fontWeight: 600,
  color: '#000000',
  width: '130px',
  height: 40,
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
  '@media (max-width:600px)': {
    marginBottom: '15px',
  },
}));

export const AcceptButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme?.primary || '#000',
  borderRadius: '8px',
  fontSize: 18,
  fontWeight: 600,
  color: theme?.text1 || '#fff',
  width: 'max-content',
  padding: '0 15px',
  height: 40,
  boxShadow: '0px 4px 20px rgba(0,0,0,0.2)',
  '&:hover': {
    backgroundColor: theme?.primary || '#000',
    opacity: 0.9,
  },
  '@media (max-width:600px)': {
    marginBottom: '15px',
  },
}));
